import React, { useEffect } from "react";
import { replace, useFormik } from "formik";
import { Col, Modal, Row } from "antd";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import { lengths } from "../Shared/Constants";
import CommonButton from "../Components/Buttons/CommonButton";
import { handleloading } from "../Store/Redux/Reducers/Dashboardreducers";
import {
  AcceptNumbersandLetters,
  CatchMessage,
  JSONtoformdata,
  TrimStart,
} from "../Shared/Methods";
import { CreateDeviceDate, UpdateDeviceDate } from "../Services/ApiServices";
import classes from "./Modal.module.css";
import Loader from "../SharedComponents/Loader/Loader";
import Commonswitch from "../Components/CommonForms/CommonSwitch";
import CommonInputTwo from "../Components/CommonForms/CommonInputTwo";
import Commonselectfield from "../Components/CommonForms/CommonSelectField";

interface formikprops {
  device_name: any;
  device_code: any;
  macAddress: any;
  imeiNumber: any;
  description: any;
  secret_key: any;
  baudrate: any;
  databits: any;
  parity: any;
  relay1: any;
  relay2: any;
  issecretkey: boolean;
  relay1_name: string;
  relay2_name: string;
}

interface props {
  handleSuccess: (type: string) => void;
  Action?: string;
  item?: any;
  open: boolean;
  closable: boolean;
  onCancel: () => void;
  DropDowns: any;
  DropdownMethods: any;
}

const validation = Yup.object().shape({
  // isrelay_name: Yup.boolean(),
  issecretkey: Yup.boolean(),
  device_name: Yup.string().required("Device Name is required"),
  device_code: Yup.string().required("Device Code is required"),
  secret_key: Yup.string().when("issecretkey", {
    is: (issecretkey: any) => (issecretkey ? true : false),
    then: () => Yup.string().required("Secret Key is required"),
  }),
  // relay1_name: Yup.string().when("isrelay_name", {
  //   is: (isrelay_name: any) => isrelay_name,
  //   then: () => Yup.string().required("Relay One is required"),
  // }),

  // relay2_name: Yup.string().when("isrelay_name", {
  //   is: (isrelay_name: any) => isrelay_name,
  //   then: () => Yup.string().required("Relay Two is required"),
  // }),

  // macAddress: Yup.string().required("Mac Address is required"),
  // imeiNumber: Yup.string().required("Imei Number is required"),
  // api_call_duration: Yup.string().required("Api Call Duration is required"),
});
function DeviceCreateModal({
  handleSuccess,
  Action,
  item,
  open,
  closable,
  onCancel,
  DropDowns,
  DropdownMethods,
}: props) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);
  const { getBaudrateDropDown, getParityDropDown, getDataBitsDropDown } =
    DropdownMethods || {};
  const { Baudrate, Parity, Databits } = DropDowns;

  const dispatch = useDispatch();
  const {
    values,
    setValues,
    handleChange,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
  } = useFormik({
    initialValues: {
      device_name: "",
      device_code: "",
      macAddress: "",
      imeiNumber: "",
      description: "",
      secret_key: "",
      // baudrate: null,
      // databits: null,
      // parity: null,
      relay1: false,
      relay2: false,
      issecretkey: Action !== "Update" ? true : false,
      // api_call_duration: "",
      // relay1_name: "",
      // relay2_name: "",
      // isrelay_name: false,
    },
    validationSchema: validation,
    onSubmit: (value) => {
      if (Action === "Create") {
        HandleCreateDevice();
      } else if (Action === "Update") {
        HandleUpdateDevice();
      } else if (Action === "Replace") {
        handleReplaceDevice();
      }
    },
  });

  useEffect(() => {
    if (item?.deviceId) {
      setValues({
        ...values,
        device_name: item?.deviceName || "",
        device_code: item?.device_code || "",
        macAddress: item?.macAddress || "",
        imeiNumber: item?.imeiNumber || "",
        description: item?.description || "",
        // api_call_duration: item?.api_call_duration || "",
        // baudrate: item?.baudrate || null,
        // databits: item?.databits || null,
        // parity: item?.parity !== "" ? item?.parity : null,
        // relay1: item?.relay1 ? true : false,
        // relay2: item?.relay2 ? true : false,
        relay1: false,
        relay2: false,
        // issecretkey: false,
        // relay1_name: item?.relay1_name,
        // relay2_name: item?.relay2_name,
        // isrelay_name: true,
      });
    }
    // getBaudrateDropDown();
    // getParityDropDown();
    // getDataBitsDropDown();
  }, [item]);

  const handleReplaceDevice = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...values,
      deviceId: item?.deviceId,
      // relay1: values?.relay1 ? 1 : 0,
      // relay2: values?.relay2 ? 1 : 0,
      relay1: 0,
      relay2: 0,
      for_replace: 1,
    };

    const finalData = { ...finalObj } as Partial<formikprops>;
    delete finalData?.description;
    delete finalData?.issecretkey;

    UpdateDeviceDate(JSONtoformdata(finalData))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          handleSuccess("replace");
          toast.success(res?.data?.msg);
          onCancel();
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const HandleCreateDevice = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...values,
      // relay1: values?.relay1 ? 1 : 0,
      // relay2: values?.relay2 ? 1 : 0,
      relay1: 0,
      relay2: 0,
    };

    const finalData = { ...finalObj } as Partial<formikprops>;
    delete finalData?.issecretkey;

    CreateDeviceDate(JSONtoformdata(finalData))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          handleSuccess("create");
          toast.success(res?.data?.msg);
          onCancel();
        }
        if (res?.data?.status == 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const HandleUpdateDevice = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...values,
      deviceId: item?.deviceId,
      // relay1: values?.relay1 ? 1 : 0,
      // relay2: values?.relay2 ? 1 : 0,
      relay1: 0,
      relay2: 0,
    };

    const finalData = { ...finalObj } as Partial<formikprops>;
    delete finalData?.issecretkey;

    UpdateDeviceDate(JSONtoformdata(finalData))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          handleSuccess("update");
          toast.success(res?.data?.msg);
          onCancel();
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      <Loader isLoader={loading} />
      <Modal open={open} closable={closable} width={700} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>{Action} Device</h4>

          <Row gutter={[16, 16]}>
            <Col md={12} sm={12} xs={24}>
              <CommonInputTwo
                name="device_name"
                value={values.device_name}
                onChange={(e) => {
                  setFieldValue("device_name", TrimStart(e.target.value));
                }}
                required={true}
                error={errors}
                touched={touched}
                labelname="Device Name"
                maxLength={lengths.Names}
              />
            </Col>
            <Col md={12} sm={12} xs={24}>
              <CommonInputTwo
                name="device_code"
                value={values.device_code}
                onChange={(e) => {
                  if (AcceptNumbersandLetters(e.nativeEvent.data)) {
                    setFieldValue("device_code", e.target.value);
                  }
                }}
                required={true}
                error={errors}
                touched={touched}
                labelname="Device Code"
                maxLength={lengths.DeviceCode}
                readonly={Action === "Create" ? false : true}
              />
            </Col>
            {Action === "Update" ? null : (
              <Col md={12} sm={12} xs={24}>
                <CommonInputTwo
                  name="secret_key"
                  value={values.secret_key}
                  onChange={(e) => {
                    if (AcceptNumbersandLetters(e.nativeEvent.data)) {
                      setFieldValue("secret_key", e.target.value);
                    }
                  }}
                  required={true}
                  error={errors}
                  touched={touched}
                  labelname="Secret Key"
                  maxLength={lengths.SecretKey}
                  // readonly={Action === "Create" ? false : true}s
                />
              </Col>
            )}
            {/* <Col  md={8} sm={12} xs={24}>
              <CommonInputTwo
                name="macAddress"
                value={values.macAddress}
                onChange={handleChange}
                // required={true}
                // error={errors}
                // touched={touched}
                labelname="Mac Address"
                maxLength={lengths.Names}
                readonly={Action === "Create" ? false : true}
              />
            </Col> */}

            {/* <Col  md={8} sm={12} xs={24}>
              <CommonInputTwo
                name="imeiNumber"
                value={values.imeiNumber}
                onChange={handleChange}
                // required={true}
                // error={errors}
                // touched={touched}
                labelname="IMEI Number"
                maxLength={lengths.Names}
                readonly={Action === "Create" ? false : true}
              />
            </Col> */}
            {/* <Col  md={8} sm={12} xs={24}>
            <CommonInputTwo
              name="api_call_duration"
              value={values.api_call_duration}
              onChange={handleChange}
              required={true}
              error={errors}
              touched={touched}
              labelname="Api Call Duration (sec)"
              maxLength={lengths.Names}
            />
          </Col> */}
            {Action !== "Replace" ? (
              <Col md={12} sm={12} xs={24}>
                <CommonInputTwo
                  name="description"
                  value={values.description}
                  onChange={(e) => {
                    setFieldValue("description", TrimStart(e.target.value));
                  }}
                  error={errors}
                  touched={touched}
                  labelname="Description"
                  maxLength={lengths.Names}
                />
              </Col>
            ) : null}
            {/* {Action === "Update" ? (
              <>
                {" "}
                <Col md={12} sm={12} xs={24}>
                  <CommonInputTwo
                    name="relay1_name"
                    value={values.relay1_name}
                    onChange={(e) => {
                      setFieldValue("relay1_name", TrimStart(e.target.value));
                    }}
                    required={true}
                    error={errors}
                    touched={touched}
                    labelname="Relay One"
                    maxLength={lengths.Names}
                  />
                </Col>
                <Col md={12} sm={12} xs={24}>
                  <CommonInputTwo
                    name="relay2_name"
                    value={values.relay2_name}
                    onChange={(e) => {
                      setFieldValue("relay2_name", TrimStart(e.target.value));
                    }}
                    required={true}
                    error={errors}
                    touched={touched}
                    labelname="Realy Two"
                    maxLength={lengths.Names}
                  />
                </Col>
              </>
            ) : null} */}
            {/* <Col md={8} sm={12} xs={24}> */}
            {/* <CommonInputTwo
                name="baudrate"
                value={values.baudrate}
                onChange={(e) => {
                  if (Float_Valildation(e.target)) {
                    setFieldValue("baudrate", e.target.value);
                  }
                }}
                error={errors}
                touched={touched}
                labelname="Baudrate"
                maxLength={lengths.threshold}
                onKeyDown={AvoidSpace}
              /> */}

            {/* <Commonselectfield
                labelname="Baudrate"
                value={values.baudrate}
                onChange={(value) => {
                  setValues({ ...values, baudrate: value });
                }}
                style={{ width: "100%" }}
                options={Baudrate?.map((ele: any) => {
                  return { label: ele?.baudrate, value: ele?.baudrate };
                })}
                size="large"
                error={errors}
                touched={touched}
                required={true}
                name="baudrate"
              /> */}
            {/* </Col> */}

            {/* <Col md={8} sm={12} xs={24}> */}
            {/* <CommonInputTwo
                name="databits"
                value={values.databits}
                onChange={(e) => {
                  if (Float_Valildation(e.target)) {
                    setFieldValue("databits", e.target.value);
                  }
                }}
                touched={touched}
                labelname="Databits"
                maxLength={lengths.threshold}
                onKeyDown={AvoidSpace}
              /> */}

            {/* <Commonselectfield
                labelname="Databits"
                value={values.databits}
                onChange={(value) => {
                  setValues({ ...values, databits: value });
                }}
                style={{ width: "100%" }}
                options={Databits?.map((ele: any) => {
                  return { label: ele?.description, value: ele?.id };
                })}
                size="large"
                error={errors}
                touched={touched}
                required={true}
                name="databits"
              />
            </Col> */}
            {/* <Col md={8} sm={12} xs={24}> */}
            {/* <CommonInputTwo
                name="parity"
                value={values.parity}
                onChange={(e) => {
                  if (Float_Valildation(e.target)) {
                    setFieldValue("parity", e.target.value);
                  }
                }}
                error={errors}
                touched={touched}
                labelname="Parity"
                maxLength={lengths.threshold}
                onKeyDown={AvoidSpace}
              /> */}

            {/* <Commonselectfield
                labelname="Parity"
                value={values.parity}
                onChange={(value) => {
                  setValues({ ...values, parity: value });
                }}
                style={{ width: "100%" }}
                options={Parity?.map((ele: any) => {
                  return { label: ele?.description, value: ele?.id };
                })}
                size="large"
                error={errors}
                touched={touched}
                required={true}
                name="parity"
              />
            </Col> */}
            {/* <Col md={8} sm={12} xs={24} className="reports_switch">
              <Commonswitch
                checked={values.relay1}
                onClick={() => setFieldValue("relay1", !values.relay1)}
                labelname="Relay One"
                name="relay1"
              />
            </Col>
            <Col md={8} sm={12} xs={24} className="reports_switch">
              <Commonswitch
                checked={values.relay2}
                onClick={() => setFieldValue("relay2", !values.relay2)}
                labelname="Relay Two"
                name="relay2"
              />
            </Col> */}
          </Row>
          <div className={classes.modal_button_container}>
            <CommonButton
              name="Submit"
              onClick={handleSubmit}
              type="submit"
              classname="submit_btn"
            />
            <CommonButton
              name="Cancel"
              type="button"
              onClick={() => onCancel()}
              style={{ backgroundColor: "#eb3131" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default DeviceCreateModal;
